import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-records",
  "use": "icon-records-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-records\"><path d=\"M721.92 468.196a432.924 432.924 0 0 0 188.302 67.697V706.56a267.947 267.947 0 0 1-190.578 198.542 267.947 267.947 0 0 1-190.008-199.68V534.756a441.458 441.458 0 0 0 186.595-66.56h3.413m0-72.25v2.276a374.329 374.329 0 0 1-219.59 81.92h-27.307V711.68a325.973 325.973 0 0 0 246.897 253.156 327.111 327.111 0 0 0 247.467-254.863V478.436h-27.307a374.329 374.329 0 0 1-219.022-80.214z\" p-id=\"17003\" fill=\"#ffffff\" /><path d=\"M910.222 54.613H56.89v910.223H455.11v-56.89H113.778V111.503h739.555v284.445h56.89V54.613z\" p-id=\"17004\" fill=\"#ffffff\" /><path d=\"M719.644 625.778a56.889 56.889 0 1 1-56.888 56.889 56.889 56.889 0 0 1 56.888-56.89m0-56.888a113.778 113.778 0 1 0 113.778 113.778 113.778 113.778 0 0 0-113.778-113.778z m19.912-343.609h-568.89v56.889h568.89V225.28zM398.222 452.836H170.667v56.888h227.555v-56.888z m0 227.555H170.667v56.889h227.555v-56.889z\" p-id=\"17005\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/records.svg
// module id = g4yi
// module chunks = 51